import { render, staticRenderFns } from "./edutalk-brank.vue?vue&type=template&id=29d13a2b&scoped=true"
import script from "./edutalk-brank.vue?vue&type=script&lang=js"
export * from "./edutalk-brank.vue?vue&type=script&lang=js"
import style0 from "./edutalk-brank.vue?vue&type=style&index=0&id=29d13a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d13a2b",
  null
  
)

export default component.exports